import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { Toggle } from '@econsult/econsult-ui/dist/components/Toggle';
import GenericModal from 'components/Modal/GenericModal';
import RichTextEditor from 'components/RichTextEditor';
import { SuccessToast } from 'components/Toast';
import { marked } from 'marked';
import React from 'react';
import theme from 'styles/theme';
import {
  ExtraSummaryButtonContainer,
  ExtraSummaryContainer,
  ExtraSummaryResponseContainer,
  SummaryModalToggleContainer,
} from './styles';

type SummaryModalProps = {
  showModal: boolean;
  handleCloseModal: () => void;
  summary: string;
  title: string;
  isLetterVersion?: boolean;
  onToggleLetterVersion?: () => void;
};

export const SummaryModal: React.FC<SummaryModalProps> = ({
  showModal,
  handleCloseModal,
  summary,
  title,
  isLetterVersion = false,
  onToggleLetterVersion,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(summary);
    toast.success(<SuccessToast message={`${title} copied to clipboard`} />, { icon: false, autoClose: 6000 });
  };
  const isReferralOrPatient = title === 'Referral Summary' || title === 'Patient-Facing Summary';
  const htmlSummary = marked.parse(summary, { async: false });
  return (
    <GenericModal
      isOpen={showModal}
      onClose={handleCloseModal}
      title={title}
      styles={{ background: theme.colorBackgroundSoftWhite }}
      fontStyles={{ fontSize: '16px', fontWeight: 600, color: theme.colorPrimaryPrimary100 }}
      showCloseButton
    >
      <ExtraSummaryResponseContainer data-automation="SummaryResponseContainer">
        <ExtraSummaryContainer data-automation="SummaryContainer">
          {htmlSummary && <RichTextEditor value={htmlSummary} onChange={() => {}} isReadOnly />}
        </ExtraSummaryContainer>
        <SummaryModalToggleContainer>
          {isReferralOrPatient && onToggleLetterVersion && (
            <Toggle
              isChecked={isLetterVersion}
              onClick={onToggleLetterVersion}
              label="Letter format"
              labelHidden={false}
            />
          )}
          <div />
        </SummaryModalToggleContainer>
        <ExtraSummaryButtonContainer data-automation="ExtraSummaryButtonContainer">
          <Button
            size="small"
            state="secondary"
            id="CloseSummaryModalButton"
            onClick={handleCloseModal}
            data-automation="CloseSummaryModalButton"
            style={{ height: '42px', padding: '0 16px', fontSize: '16px' }}
          >
            Close
          </Button>
          <Button
            size="small"
            state="primary"
            id="CopySummaryButton"
            onClick={handleCopy}
            data-automation="CopySummaryButton"
            style={{ height: '42px', padding: '0 16px', fontSize: '16px' }}
          >
            Copy
          </Button>
        </ExtraSummaryButtonContainer>
      </ExtraSummaryResponseContainer>
    </GenericModal>
  );
};
